import React, { Component } from 'react';
import { connect } from 'react-redux'
import Auth from '../../Auth/Auth';
import { Nav, INavLink } from '@fluentui/react';
import ProfilePicture from "@dsalvagni/react-profile-picture"
import '@dsalvagni/react-profile-picture/dist/ProfilePicture.css';
import Subscriptions from './Subscriptions'
import Invoices from './Invoices'
import { DefaultButton, PrimaryButton, DialogFooter, IconButton, Modal, DayOfWeek,DatePicker, MaskedTextField } from '@fluentui/react';
import { Password } from './Password'
import { Contact } from './Contact'
import { FeatureRequest} from './FeatureRequest'
import { AllNotifications } from './AllNotifications';
import { AUTH_CONFIG } from '../../Auth/auth0-variables';
import axios from 'axios';
import { updateUserProfile } from "../../actions"
import ShiftsContext from '../../Context/ShiftsContext'
import { showToast } from '../../actions'
import UpdatePassword from './UpdatePassword';
import PortalComponent from '../../UiKit/SharedComponents/PortalComponent';

const styles = {
    p: {
        fontSize: '14px',
        lineHeight: 1.71,
        color: '#7b8397',
        marginTop: '10px'
    },
    error: {
        color: 'red'
    },
    container: {
        width: 260
    }
};


const DayPickerStrings = {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    goToToday: 'Go to today',
    weekNumberFormatString: 'Week number {0}',
    prevMonthAriaLabel: 'Previous month',
    nextMonthAriaLabel: 'Next month',
    prevYearAriaLabel: 'Previous year',
    nextYearAriaLabel: 'Next year',
    prevYearRangeAriaLabel: 'Previous year range',
    nextYearRangeAriaLabel: 'Next year range',
    closeButtonAriaLabel: 'Close'
};


export class Profile extends React.Component {
    static contextType = ShiftsContext
    constructor(props) {
        super(props);
        this.auth = new Auth();
        
        this.state = {
            open: false,
            accountOpen: false,
            modalStep: this.props.profilePage,
            phoneNumber: this.props.user.phoneNumber ? this.props.user.phoneNumber : "",
            dob: this.props.user.dob ? new Date(this.props.user.dob) : null,
            phoneNumberChanged: false,
            dobChanged:false,
            phoneNumberErrorMsg: '',
            openSnack: false,
            showModal: false,
            navKey: this.props.profilePage
        };
        this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
        this.updatePhoneNumber = this.updatePhoneNumber.bind(this);
        this.profilePictureRef = React.createRef();
    }

    componentDidMount() {

        var links = [
            {
                name: 'Profile',
                key: '1',
                page: '1',
            },
        ]

      

        links.push({
            name: 'Contact Support',
                key: '6',
                page: '6',
            },
            {
                name: 'Feature Request',
                key: '7',
                page: '7',
            });

        this.setState({
            
            links: [
                {
                    links
                }
            ]
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.profilePage != this.props.profilePage) {
            this.setState({ navKey: nextProps.profilePage, modalStep: nextProps.profilePage})
        }
    }

    handleClose = () => {
        this.setState({ accountOpen: false });
    };

    handleClick = (event) => {
        event.preventDefault();
        this.setState({
            open: true,
            anchorEl: event.currentTarget
        });
    };

    handleLogoutClick = () => {
        this.auth.logout();
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
        });
    };

    changeStep = (e, x) => {
        e.preventDefault();
        this.setState({
            modalStep: x,
        });
    };

    handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ openSnack: false });
    };

    updatePhoneNumber(e) {
        e.preventDefault();
        this.setState({ phoneNumberErrorMsg: '' });

        if (this.telephoneCheck(this.state.phoneNumber.replace(/\D/g, ''))) {
            var model = {
                Value: this.state.phoneNumber.replace(/\D/g, '')
            }
            axios.post(AUTH_CONFIG.API_URL + "/api/Account/UpdatePhoneNumber", model)
                .then((response) => {
                  
                    this.props.user.phoneNumber = this.state.phoneNumber.replace(/\D/g, '');
                    this.props.dispatch(updateUserProfile(this.props.user))
                    this.setState({ phoneNumberErrorMsg: '', phoneNumberChanged: false });
                    this.props.dispatch(showToast({ show: true, message: "Phone number successfully updated." }))
                });
        } else {
            this.setState({ phoneNumberErrorMsg: 'Invalid phone number' })
        }
    }

    telephoneCheck(str) {
        return /^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/.test(str);
    }

    updateDob(e) {
        e.preventDefault();
        var model = {
            Value: this.state.dob
        }
        axios.post(AUTH_CONFIG.API_URL + "/api/Account/UpdateDOB", model)
            .then((response) => {

                this.props.user.dob = this.state.dob;
                this.props.dispatch(updateUserProfile(this.props.user))
                this.setState({ dobChanged: false });
                this.props.dispatch(showToast({ show: true, message: "DOB successfully updated." }))
            });
    }

    handlePhoneNumberChange = (event, value) => {
        this.setState({
            phoneNumber: value,
            phoneNumberChanged: true
        });
    }
    onOpenModal = (event) => {
        event.preventDefault();

        const { toggleProfilePic } = this.context
        toggleProfilePic()


        //this.setState({
        //    showModal: true
        //});
    };


    _renderMenuList = (menuListProps, defaultRender) => {
        return (
            <div>

                {defaultRender(menuListProps)}
            </div>
        );
    };


    _onLinkClick = (e, item) => {
        this.setState({
            modalStep: item.page,
            navKey:item.page
        })
    }

    _onSelectDate = (date) => {
        this.setState({
            dob: date,
            dobChanged: true
        })
    }

    render() {
        return (
            <div className="displayflex flex1 height100" style={{overflow:'hidden'}}>
                <div className="displayflex flexcolumn profile-nav" style={{ overflowY: 'auto' }}>
                    
                    <div className="profile-header-block p20">
                        <h2 className="page-header">Profile Settings</h2>
                    </div>
                    <Nav
                        selectedKey={this.state.navKey}
                        onLinkClick={this._onLinkClick}
                        styles={{
                            root: {
                                width: 230,
                            }
                        }}
                        ariaLabel="Nav basic example"
                        groups={this.state.links}
                    />
                </div>
                <div className="displayflex flex1 height100" style={{  overflowY:'auto' }}>
                    <IconButton iconProps={{ iconName: 'Cancel' }} title="Close" className="profile-close" onClick={() => this.props.closePanel()} />
                    {this.state.modalStep == '1' &&
                        <div class="content-section width100">
                         <div className="profile-header-block">
                            <h2 className="page-header">User Profile</h2>
                        </div>
                        <div class="py20">
                           
                                <div class="profile-overview">
                                    <div class="form-row" style={{ 'overflow': 'hidden', flexDirection:'row' }}>
                                        <div class="icon-object">
                                            {!this.props.user.userImg &&
                                             <i class="ms-Icon ms-Icon--Contact"></i>
                                            }
                                            {this.props.user.userImg &&
                                                <img className="profile-img" src={process.env.REACT_APP_CDN_URL + this.props.user.userImg} />
                                            }
                                    </div>
                                    <div id="angularupload2" className="profile-pic-upload">
                                        <a onClick={(e)=>this.onOpenModal(e)}>Update</a>
                                    </div>
                                    </div>
                                    <div class="form-row">
                                    <label for="blockName" class="small-label mb5">Name</label>
                                    <span class="value ng-binding">{this.props.user.firstName} {this.props.user.lastName}</span>
                                    </div>
                                    <div class="form-row">
                                    <label for="blockName" class="small-label mb5">User name</label>
                                    <span class="value ng-binding">{this.props.user.email}</span>
                                    </div>
                                    <div class="form-row">
                                    <label for="blockName" class="small-label mb5">Phone number</label>

                                    <div className="displayflex flex1">
                                        <MaskedTextField onChange={this.handlePhoneNumberChange} styles={{ fieldGroup: { width: 150 } }} value={this.state.phoneNumber} mask="(999) 999-9999" />
                                        <span style={styles.error}>{this.state.phoneNumberErrorMsg}</span>
                                    </div>
                                    {this.state.phoneNumberChanged &&
                                        <a onClick={(e) => this.updatePhoneNumber(e)}>Update</a>
                                    }
                                        
                                </div>
                                <div class="form-row">
                                    <label for="blockName" class="small-label mb5">DOB</label>

                                    <DatePicker
                                        onSelectDate={this._onSelectDate}
                                        value={this.state.dob}
                                        firstDayOfWeek={DayOfWeek.Sunday}
                                        strings={DayPickerStrings}
                                        placeholder="Select a date..."
                                        className="short-datepicker mr5"
                                        styles={{ root: { height: '38px' }, textField: { height: '38px', lineHeight: '38px' }, icon: { display: 'none' } }}
                                    />
                                    {this.state.dobChanged &&
                                        <a onClick={(e) => this.updateDob(e)}>Update</a>
                                    }
                                    </div>
                                    <div class="form-row">
                                        <label for="blockName" class="small-label mb5">Login PIN</label>
                                        <span class="value ng-binding">{this.props.user.pin}</span>
                                    </div>
                                    <div class="form-row change-link" style={{ marginTop: '15px' }}>
                                        <a href="" onClick={(e) => this.changeStep(e, 2)}>Change your password</a>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    }
                    {this.state.modalStep == '2' &&
                        <div class="content-section  width100">
                            <div className="profile-header-block">
                                <h2 className="page-header">Update Password</h2>
                            </div>
                            <div class="py20">
                             <UpdatePassword />
                                <div className="m-t-30">
                                    <a href="" onClick={(e) => this.changeStep(e, 1)}>Cancel</a>
                                </div>
                            </div>
                        </div>
                }
                    {this.state.modalStep == '3' &&
                        <div class="content-section width100">
                            <div className="profile-header-block">
                            <h2 className="page-header">Notifications</h2>
                            </div>
                        <div class="notification-container list py20">
                            <AllNotifications />
                        </div>
                    </div>
                    }
                    {this.state.modalStep == '4' &&
                        <div class="content-section  width100">
                            <div className="profile-header-block">
                            <h2 className="page-header">Subscriptions</h2>
                            </div>
                            <div class="py20 ">
                            <Subscriptions />
                        </div>
                    </div>
                    }
                    {this.state.modalStep == '5' &&
                        <div class="content-section width100">
                            <div className="profile-header-block">
                            <h2 className="page-header">Invoices</h2>
                            </div>
                            <div class="py20">
                            <div class="profile-overview">
                                <Invoices />
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.modalStep == '6' &&
                        <div class="content-section width100">
                        <div className="profile-header-block">
                            <h2 className="page-header">Contact Support</h2>
                            </div>
                            <div class="py20">
                            <div class="">
                                <Contact type="support" />
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.modalStep == '7' &&
                        <div class="content-section width100">
                        <div className="profile-header-block">
                            <h2 className="page-header">Suggest a feature</h2>
                            </div>
                            <div class="py20">
                            <p className="mb20">Do you have an idea for a new feature or something that will make your job easier? <br />Please let us know and we will make it happen!</p>
                            <div class="">
                                <FeatureRequest />
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.modalStep == '8' &&
                        <div class="content-section width100">
                            <div className="profile-header-block">
                                <h2 className="page-header">Facilities</h2>
                            </div>
                            <div class="py20">
                                <div class="">
                                </div>
                            </div>
                        </div>
                    }
                </div>
              
            </div>
        );
    }
}

const mapStateToProps = state => ({
    profilePage: state.rootReducer.profilePage,
    user: state.userProfile
});

export default connect(mapStateToProps)(Profile);



